<template>
    <div>
        <div class="d-flex flex-column flex-lg-row justify-space-between align-lg-center mb-4">
        <div class="d-inline-flex flex-wrap rounded-lg mobile-header-border justify-space-between align-center">
            <v-col cols="2" lg="auto">
                <v-card elevation="0" class="pa-4 rounded-lg">
                    <div class="d-flex flex-column flex-lg-row align-center align-lg-center text-center text-lg-left">
                        <div class="rounded-lg pa-3 mb-2 mb-sm-0 mr-lg-2 plusIndigoLighten5">
                            <v-icon size="36" color="plusIndigoDarken4">mdi-account-group</v-icon>
                        </div>
                        <div>
                            <div class="font-roboto text-h5">
                                <v-progress-circular size="20" v-if="loading" :width="2"
                                    indeterminate></v-progress-circular>
                                <span v-else>{{ members.length }}</span>
                            </div>
                            <div class="text-body-2 font-roboto">{{ $t("message.total_members") }}</div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="2" lg="auto">
                <v-card elevation="0" class="pa-4 rounded-lg">
                    <div class="d-flex flex-column flex-lg-row align-center align-lg-center text-center text-lg-left">
                        <div class="rounded-lg pa-3 mb-2 mb-sm-0 mr-lg-2 plusLightGreenLighten5">
                            <v-img :src="require('@/assets/icons/admin+/money.svg')" width="36" height="36"></v-img>
                        </div>
                        <div>
                            <div class="font-roboto text-h5">
                                <v-progress-circular size="20" v-if="loading" :width="2"
                                    indeterminate></v-progress-circular>
                                <span v-else>{{ payingMembers }}</span>
                            </div>
                            <div class="text-body-2 font-roboto">{{ $t("message.paying_members") }}</div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="2" lg="auto">
                <v-card elevation="0" class="pa-4 rounded-lg">
                    <div class="d-flex flex-column flex-lg-row align-center align-lg-center text-center text-lg-left">
                        <div class="rounded-lg pa-3 mb-2 mb-sm-0 mr-lg-2 plusBlueLighten5">
                            <v-icon size="36" color="plusBlueDarken4">mdi-currency-usd-off</v-icon>
                        </div>
                        <div>
                            <div class="font-roboto text-h5">
                                <v-progress-circular size="20" v-if="loading" :width="2"
                                    indeterminate></v-progress-circular>
                                <span v-else>{{ freeMembers }}</span>
                            </div>
                            <div class="text-body-2 font-roboto">{{
                                $t("message.free_memberships") }}</div>
                        </div>
                    </div>
                </v-card>
            </v-col>

            <v-col cols="2" lg="auto">
                <v-card elevation="0" class="pa-4 rounded-lg">
                    <div class="d-flex flex-column flex-lg-row align-center align-lg-center text-center text-lg-left">
                        <div class="rounded-lg pa-3 mb-2 mb-sm-0 mr-lg-2 plusAmberLighten5">
                            <v-icon size="36" color="plusAmberDarken4">mdi-block-helper</v-icon>
                        </div>
                        <div>
                            <div class="font-roboto text-h5">
                                <v-progress-circular size="20" v-if="loading" :width="2"
                                    indeterminate></v-progress-circular>
                                <span v-else>{{ noMembershipMembers }}</span>
                            </div>
                            <div class="text-body-2 font-roboto">{{ $t("message.no_membership") }}</div>
                        </div>
                    </div>
                </v-card>
            </v-col>
        </div>

        <div class="d-flex justify-end justify-lg-start mt-2 mt-lg-0 ml-lg-2">
            <v-btn outlined text elevation="0" color="primary" small @click="showMembersGraph = !showMembersGraph">
                <v-icon class="mr-1">{{ showMembersGraph ? 'mdi-table' : 'mdi-chart-bar' }}</v-icon>
                <span v-if="!isSmallerDisplay()">{{ showMembersGraph ? $t('message.table') : $t('message.graph')
                    }}</span>
            </v-btn>
        </div>
        </div>


        <!-- Filters Card -->
        <v-card v-if="!showMembersGraph" elevation="0" class="mb-lg-3 mt-1 pa-6 rounded-lg border-filter">
            <v-card-text class="pa-0 mb-1">
                <v-row>
                    <v-col class="pb-0" cols="12" lg="4">
                        <v-text-field :hide-details="true" dense outlined :label="$t('message.search_by_name_filter')"
                            v-model="filterTableValue" prepend-inner-icon="mdi-magnify">
                        </v-text-field>
                    </v-col>
                    <v-col class="pb-0  d-lg-flex" cols="12" lg="2" :class="displayFilters ? '' : 'd-lg-flex d-none'">
                        <tags-select v-if="availableTags" v-model="tagFilter" :label="$t('message.label_filter')"
                            :items="availableTags"></tags-select>
                    </v-col>
                    <v-col class="pb-0  d-lg-flex" cols="12" lg="2" :class="displayFilters ? '' : 'd-lg-flex d-none'">
                        <v-select :label="$t('message.member_type_filter')" :hide-details="true" item-text="text"
                            item-value="value" outlined dense :items="memberTypes" v-model="minorsFilter">
                        </v-select>
                    </v-col>
                    <v-col class="pb-0" cols="12" lg="2">
                        <v-select clearable :label="$t('message.membership_type')" :hide-details="true" item-text="text"
                            item-value="value" outlined dense :items="membershipTypes"
                            v-model="membershipTypeFilter"></v-select>
                    </v-col>
                    <v-col class="pb-0  d-lg-flex" cols="12" lg="2" :class="displayFilters ? '' : 'd-lg-flex d-none'">
                        <v-select :label="$t('message.membership_filter')" :hide-details="true" item-text="text"
                            item-value="value" outlined dense :items="statusTypes" v-model="statusFilter">
                        </v-select>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" class="pa-0 d-lg-none d-flex justify-center">
                        <v-card-actions class="pr-0 mr-0">
                            <v-btn @click="displayFilters = !displayFilters" text plain
                                class="pa-0 ma-0 text-lowercase">
                                <span
                                    class="font-roboto text-body-2 text-decoration-underline text-primary text-uppercase">
                                    {{
                                        !displayFilters ? $t('message.show_more_filters') :
                                            $t('message.members_hide_filters') }}
                                </span>
                            </v-btn>
                        </v-card-actions>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>


        <!-- Desktop Data Table -->
        <v-card v-if="!showMembersGraph" class="mt-3" elevation="0" :outlined="isSmallerDisplay()">
            <v-data-table :mobile-breakpoint="0" class="elevation-0 mt-1 active-members-table" outlined
                v-model="selectedItems" item-key="_id" :headers="isSmallerDisplay() ? headersMobile : headers"
                show-select :custom-sort="membersSort" :loading="loading" :loading-text="$t('message.loading')"
                :items="filteredMembers" :no-data-text="$t('message.no_data')" :footer-props="{
                    itemsPerPageText: $t('message.rows_per_page'),
                    itemsPerPageOptions: [25, 50, 75, -1],
                }" :hide-default-header="isSmallerDisplay()">


                <template v-slot:header.data-table-select>
                    <!-- remove data-table-select header -->
                </template>

                <template v-slot:top>
                    <v-card-actions class="ml-2 mb-8 mt-4" outlined>
                        <v-row>
                            <v-col cols="8" class="d-flex align-center pt-0">
                                <div class="d-flex flex-column">
                                    <v-checkbox class="font-roboto text-body-2" hide-details
                                        :label="isSmallerDisplay() ? $t('message.select_all') : $t('message.select_all') + ' (' + $t('message.members_selected', [selectedItems.length + '/' + filteredMembers.length]) + ')'"
                                        @change="selectAll()"></v-checkbox>
                                    <span v-if="isSmallerDisplay()"
                                        class="text-caption plusGreyDarken1--text ml-8 mt-n1">
                                        {{ $t('message.members_selected', [selectedItems.length + '/' +
                                            filteredMembers.length]) }}
                                    </span>
                                </div>
                            </v-col>
                            <v-col cols="4" class="d-flex justify-end">
                                <v-menu elevation="0" offset-y :disabled="selectedItems.length == 0">
                                    <template v-slot:activator="{ on }">
                                        <PlusButton :disabled="selectedItems.length == 0" v-on="on" slot="activator">
                                            <span class="font-roboto text-button d-inline">{{ $t("message.actions")
                                                }}</span>
                                        </PlusButton>
                                    </template>
                                    <v-list class="font-roboto text-body-1">
                                        <v-list-item>
                                            <v-list-item-title @click="openSendEmailDialog()" class="clickable">
                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.send_emails")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title @click="openSendNotiDialog()" class="clickable">

                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.send_notifications")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item>
                                            <v-list-item-title @click="openTagsDialog()" class="clickable">

                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.update_labels")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-allowed="'send_waiver'">
                                            <v-list-item-title @click="openSendDocuDialog()" class="clickable">

                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.send_document")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-allowed="'manage_syllabus_instances'">
                                            <v-list-item-title @click="openAssignSyllabusDialog()" class="clickable">

                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.assign_syllabus")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                        <v-list-item v-if="availableCheckinClasses">
                                            <v-list-item-title @click="openBulkCheckinDialog()" class="clickable">

                                                <span :class="selectedItems.length == 0 ? 'disabled-menu' : ''">{{
                                                    $t("message.bulk_checkin")
                                                    }}</span>
                                            </v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                            </v-col>
                        </v-row>
                    </v-card-actions>
                </template>


                <!-- Table Column Templates -->
                <template v-slot:item.avatar="{ item }">
                    <div class="d-flex align-center text-xs-center clickable"
                        @click="viewMember(item._id, null, null, item.displayName)">
                        <v-badge :value="isSmallerDisplay() && !!item.lastPaymentStatusData" dot
                            :color="item.lastPaymentStatusData ? getTransactionStatusColor(item.lastPaymentStatusData.status) : ''"
                            overlap bottom right offset-x="4" offset-y="4">
                            <v-avatar size="36" v-if="item.userImageSmall || item.userImage">
                                <ImageDisplay :src="item.userImageSmall ? item.userImageSmall : item.userImage" />
                            </v-avatar>
                            <v-avatar size="36" color="plusIndigoLighten3" v-else>
                                <span class="font-roboto white--text text-subtitle-1">{{ getInitials(item.displayName)
                                    }}</span>
                            </v-avatar>
                        </v-badge>
                        <country-display class="ml-3" :country-code="item.nationality" />
                    </div>
                </template>

                <template v-slot:item.displayName="{ item }">
                    <div @click="viewMember(item._id, null, null, item.displayName)">
                        <div class="d-flex align-center font-roboto font-weight-regular text-subtitle-2">
                            {{ item.displayName }}
                        </div>
                        <!-- <v-tooltip top v-if="item.isBirthday">
                            <template v-slot:activator="{ on, attrs }">
                                <v-icon v-bind="attrs" v-on="on" color="accent">mdi-cake-variant-outline</v-icon>
                            </template>
<span>{{ $t("message.is_birthday") }}</span>
</v-tooltip> -->
                        <v-badge color="secondary" v-if="item.daysUntilBirthDate < 0" :content="item.daysUntilBirthDate"
                            overlap>
                            <v-icon color="accent">mdi-cake-variant-outline</v-icon>
                        </v-badge>
                    </div>
                </template>

                <template v-slot:item.joined="{ item }">
                    <div class="font-roboto font-weight-regular text-subtitle-2">
                        {{ item.joined ? $d(new Date(item.joined), "month_day_year", $i18n.locale) : '' }}
                    </div>
                </template>

                <template v-slot:item.dob="{ item }">
                    {{ item.dob ? $d(dateFromStringInTZ(item.dob), "month_day_year", $i18n.locale) : '' }}
                </template>


                <template v-slot:item.lastPaymentStatus="{ item }">
                    <div class="d-flex align-center justify-center">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <div v-if="item.lastPaymentStatusData" v-bind="attrs" v-on="on">
                                    <v-badge v-if="item.lastPaymentStatusData.status == 'pending_payment'" small overlap
                                        icon="mdi-email-fast-outline" color="accent">
                                        <v-btn @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                                            <v-icon v-if="item.lastPaymentStatusData.paymentType === 'cash'"
                                                :color="getTransactionStatusColor(item.lastPaymentStatusData.status)">mdi-cash-100</v-icon>
                                            <IconMembershipStatus v-else
                                                :color="getTransactionStatusColor(item.lastPaymentStatusData.status)" />
                                        </v-btn>
                                    </v-badge>
                                    <v-badge v-else-if="item.lastPaymentStatusData.recurrent" small overlap
                                        icon="mdi-sync" color="accent">
                                        <v-btn @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                                            <v-icon v-if="item.lastPaymentStatusData.paymentType === 'cash'"
                                                :color="getTransactionStatusColor(item.lastPaymentStatusData.status)">mdi-cash-100</v-icon>
                                            <IconMembershipStatus v-else
                                                :color="getTransactionStatusColor(item.lastPaymentStatusData.status)" />
                                        </v-btn>
                                    </v-badge>
                                    <v-btn v-else @click="goToTransaction(item.lastPaymentStatusData.transaction)" icon>
                                        <v-icon v-if="item.lastPaymentStatusData.paymentType === 'cash'"
                                            :color="getTransactionStatusColor(item.lastPaymentStatusData.status)">mdi-cash-100</v-icon>
                                        <IconMembershipStatus v-else
                                            :color="getTransactionStatusColor(item.lastPaymentStatusData.status)" />
                                    </v-btn>
                                </div>
                                <v-btn v-bind="attrs" v-on="on" v-else text icon @click="goToSellMembership(item)">
                                    <v-icon>mdi-ticket-confirmation-outline</v-icon>
                                </v-btn>
                            </template>
                            <span>{{ item.lastPaymentStatus ? (item.freeMembership ? $t("message.free_membership") :
                                getSubscriptionStatusText(item.lastPaymentStatusData.status)) :
                                $t("message.sell_membership") }}</span>
                        </v-tooltip>
                    </div>
                </template>

                <template v-slot:item.curriculumProgress="{ item }">
                    <div class="d-flex align-center justify-center">
                        <v-btn small icon v-if="!item.hasCurriculum && item.notBjjUser"
                            @click="viewMember(item._id, null, 'lms', item.displayName)">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <v-icon v-bind="attrs" v-on="on">mdi-school-outline</v-icon>
                                </template>
                                <span>{{ $t('message.no_syllabus_assigned') }}</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn small icon v-else-if="!item.hasCurriculum"
                            @click="viewMember(item._id, null, 'lms', item.displayName)">
                            <v-tooltip left>
                                <template v-slot:activator="{ on, attrs }">
                                    <belt-display v-bind="attrs" v-on="on" :belt="item.belt" :show-text="false" />
                                </template>
                                <span>{{ $t('message.no_syllabus_assigned') }}</span>
                            </v-tooltip>
                        </v-btn>
                        <v-btn v-else-if="item.curriculumData" small icon
                            @click="viewMember(item._id, item.curriculumData.instanceId, null, item.displayName)">
                            <belt-display
                                v-if="academy && academy.configuration && academy.configuration.hideCurriculumProgressInMembersList"
                                :belt="item.belt" :show-text="false" />
                            <v-progress-circular v-else-if="item.curriculumData.useBelts && item.curriculumData.level"
                                class="mt-1" size="30" :value="item.curriculumData.progress"
                                :color="getBeltColor(item.curriculumData.level)">
                                <span
                                    :class="'text-caption ' + getProgressTextColor(item.curriculumData.level) + '--text'">{{
                                        item.curriculumData.progress }}</span>
                            </v-progress-circular>
                            <v-progress-circular v-else class="mt-1" size="30" :value="item.curriculumData.progress"
                                :color="item.curriculumData.useBelts && item.belt ? getBeltColor(item.belt) : 'accent'">
                                <span
                                    :class="'text-caption ' + getProgressTextColor(item.curriculumData.level) + '--text'">{{
                                        item.curriculumData.progress }}</span>
                            </v-progress-circular>
                        </v-btn>
                    </div>
                </template>


                <template v-slot:item.actions="{ item }">

                    <v-menu elevation="0" offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <span v-bind="attrs" v-on="on">
                                <v-badge v-if="item.isMinor" color="accent" icon="mdi-baby-face-outline" overlap bottom>
                                    <v-btn class="ml-lg-5 rounded" x-small fab outlined elevation="0"
                                        color="plusGreyDarken1">
                                        <v-icon color="plusTextPrimary" size="16">mdi-dots-vertical</v-icon>
                                    </v-btn>
                                </v-badge>
                                <v-btn v-else class="ml-lg-5 rounded" x-small fab outlined elevation="0"
                                    color="plusGreyDarken1">
                                    <v-icon color="plusTextPrimary" size="16">mdi-dots-vertical</v-icon>
                                </v-btn>
                            </span>
                        </template>
                        <v-list class="font-roboto text-body-1">
                            <v-list-item>
                                <v-list-item-title
                                    @click="item.whatsapp ? displayPhoneDialog(item) : copyToClipboard(item.phone)">
                                    <span class="ml-2">{{ $t('message.phone') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <!-- <v-list-item>
                                <v-list-item-title>
                                    <span v-if="item.hasApp" class="ml-2">{{ item.hasApp.deviceName }}</span>
                                    <span v-else class="ml-2">{{ $t('message.no_app') }}</span>
                                </v-list-item-title>
                            </v-list-item> -->
                            <v-list-item>
                                <v-list-item-title v-if="item.lastPaymentStatusData"
                                    @click="goToTransaction(item.lastPaymentStatusData.transaction)">
                                    <span class="ml-2">{{ $t('message.transaction') }}</span>
                                </v-list-item-title>
                                <v-list-item-title v-else @click="goToSellMembership(item)">
                                    <span class="ml-2">{{ $t('message.sell_membership') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.stop="navigateTo({ name: 'bulksell', query: { userId: item._id } })">
                                <v-list-item-title>
                                    <span class="ml-2">{{ $t('message.sell_items') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="!hideCheckinCodes" @click.stop="viewUserCode(item)">
                                <v-list-item-title>
                                    <span class="ml-2">{{ $t('message.checkin_code') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item @click.stop="displaySocialPostDialog(item)" v-if="!item.isMinor">
                                <v-list-item-title>
                                    <span class="ml-2">{{ $t('message.member_shoutout') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="item.alerts > 0"
                                @click="viewMember(item._id, null, 'alerts', item.displayName)">
                                <v-list-item-title>
                                    <span class="ml-2">{{ $t('message.alerts') }}</span>
                                </v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </template>
            </v-data-table>
        </v-card>

        <!-- New Members Per Month Graph -->
        <v-card v-else class="mt-3 pa-4" elevation="0" :outlined="isSmallerDisplay()">
            <div class="text-subtitle-1 font-roboto mb-2">{{ $t('message.new_members') }}</div>
            <ApexChart type="bar" :options="membersByMonthChart.options" :series="membersByMonthChart.series"
                height="320"></ApexChart>
        </v-card>
    </div>
</template>

<script>
import BeltDisplay from "@/components/displays/BeltDisplay.vue";
import CountryDisplay from "@/components/displays/CountryFlagDisplay.vue";
// import MemberAvatar from "@/components/displays/MemberAvatar.vue";
import TagsSelect from "@/components/inputs/TagsSelect.vue";
import Api2 from "@/services/Api2";
import IconMembershipStatus from "../../components/displays/icons/IconMembershipStatus.vue";
import PlusButton from "../../components/plus/PlusButton.vue";
import ApexChart from "vue-apexcharts";

export default {
    name: "ViewActiveMembers",
    components: {
        CountryDisplay,
        BeltDisplay,
        // MemberAvatar,
        TagsSelect,
        IconMembershipStatus,
        PlusButton,
        ApexChart
    },
    props: {
        academy: Object,
        academyUser: Object,
        user: Object
    },
    data() {
        return {
            displayFilters: false,
            members: [],
            filteredMembers: [],
            selectedItems: [],
            loading: false,
            loadingMembers: false,
            allSelected: false,
            showMembersGraph: false,

            // Member counts
            payingMembers: 0,
            freeMembers: 0,
            noMembershipMembers: 0,

            // Filter values
            filterTableValue: "",
            tagFilter: null,
            minorsFilter: 'all',
            statusFilter: 'all',
            membershipTypeFilter: 'all',

            // Filter options
            availableTags: null,
            memberTypes: [
                { text: this.$t("message.all"), value: 'all' },
                { text: this.$t("message.adults_only"), value: 'adults' },
                { text: this.$t("message.minors_only"), value: 'minors' }
            ],
            statusTypes: [
                { text: this.$t("message.all"), value: 'all' },
                { text: this.$t("message.assigned_membership"), value: 'with-membership' },
                { text: this.$t("message.assigned_paid_membership"), value: 'paid-membership' },
                { text: this.$t("message.assigned_free_membership"), value: 'free-membership' },
                { text: this.$t("message.no_membership"), value: 'no-membership' }
            ],
            membershipTypes: [{ text: this.$t("message.all"), value: 'all' }],

            // Table configuration
            headers: [
                // { text: "", align: "left", sortable: false, value: "checkbox" },
                { text: "", align: "left", sortable: false, value: "avatar", width: "60px" },
                { text: this.$t("message.name"), value: "displayName", },
                { text: this.$t("message.joined_date_plus"), value: "joined" },
                { text: this.$t("message.date_of_birth"), value: "dob", align: 'center' },
                { text: this.$t("message.membership"), value: "lastPaymentStatus", align: 'center' },
                { text: this.$t("message.progress"), value: "curriculumProgress", align: 'center' },
                { text: "", align: "left", sortable: false, value: "actions" }
            ],
            headersMobile: [
                { text: "", align: "left", sortable: false, value: "avatar", width: "60px" },
                { text: this.$t("message.name"), value: "displayName" },
                { text: "", align: "left", sortable: false, value: "actions" }
            ],

            // Settings
            hideCheckinCodes: false,
            availableCheckinClasses: null,
            membersTableSort: this.$route.query.sort_members
        };
    },
    computed: {
        // Members are already fully loaded client-side (this.members) - no need for a
        // separate backend call, we can bucket by `joined` directly. Trailing 12 fixed
        // calendar months, zero-filled, same convention as GrowthCentral's trendlines.
        membersByMonthChart() {
            const months = [];
            const from = new Date();
            from.setDate(1);
            from.setHours(0, 0, 0, 0);
            from.setMonth(from.getMonth() - 11);
            for (let i = 0; i < 12; i++) {
                const date = new Date(from);
                date.setMonth(date.getMonth() + i);
                months.push({ key: date.getFullYear() + "-" + date.getMonth(), date, count: 0 });
            }
            for (const m of this.members) {
                if (!m.joined) continue;
                const joinedDate = new Date(m.joined);
                const key = joinedDate.getFullYear() + "-" + joinedDate.getMonth();
                const bucket = months.find((mo) => mo.key === key);
                if (bucket) bucket.count++;
            }
            return {
                series: [{ name: this.$t("message.new_members"), data: months.map((mo) => mo.count) }],
                options: {
                    chart: { type: "bar", toolbar: { show: false }, background: "none" },
                    theme: { mode: this.isDarkMode() ? "dark" : "light" },
                    plotOptions: { bar: { borderRadius: 4, columnWidth: "50%" } },
                    colors: [this.themeColor("primary")],
                    dataLabels: { enabled: false },
                    grid: { show: false },
                    legend: { show: false },
                    xaxis: {
                        categories: months.map((mo) => this.$d(mo.date, "month_year", this.$i18n.locale)),
                    },
                },
            };
        },
    },
    watch: {
        filterTableValue: {
            handler: function (newValue) {
                this.filterTable(newValue);
            },
        },
        tagFilter: {
            handler: function () {
                this.filterTableByTag();
            },
        },
        minorsFilter: {
            handler: function () {
                this.filterTableByMinors();
            },
        },
        statusFilter: {
            handler: function () {
                this.filterTableByStatus();
            },
        },
        membershipTypeFilter: {
            handler: function () {
                this.filterTableByMembership();
            },
        },
    },
    created() {
        this.getMembers();
        this.getAvailableTags();
        this.loadCheckinClasses();
    },
    methods: {
        // Data loading methods
        async getMembers() {
            this.loading = true;
            this.loadingMembers = true;
            let data = null;
            try {
                const response = await Api2().get(
                    "admins/academy/" +
                    this.$store.state.selectedAcademy +
                    "/members?get_subscriptions=true&get_curriculum_instances=true"
                );

                data = response.data;
                if (data && data.approved) {
                    this.members = data.approved;
                    if (data.memberships && data.memberships.length)
                        this.membershipTypes = this.membershipTypes.concat(data.memberships);

                    const phoneCode = data.phoneCode;
                    this.payingMembers = data.payingMembers;
                    this.freeMembers = data.freeMembersCount;
                    this.noMembershipMembers = data.noMembershipCount;

                    // Process member data
                    for (const m of this.members) {
                        const daysUntilBirthDate = this.daysUntilBirthDate(m.dob);
                        m.isBirthday = daysUntilBirthDate == 0 ? true : false;
                        m.whatsapp = this.getWhatsAppLink(phoneCode, m.phone);
                        m.transactionIcon = this.getTransactionPaymentTypeIcon(m);
                        if (daysUntilBirthDate < 0 && daysUntilBirthDate > -3)
                            m.daysUntilBirthDate = daysUntilBirthDate;
                    }

                    this.filteredMembers = this.members;
                    if (this.membersTableSort) {
                        const split = this.membersTableSort.split('|');
                        const columnName = split[0];
                        const isDesc = split[1] == 'true' ? true : false;
                        this.membersSort(this.filteredMembers, [columnName], [isDesc]);
                    }
                }

                this.$emit('members-loaded', data);
            } catch (e) {
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            } finally {
                this.loadingMembers = false;
                this.loading = false;
            }
        },

        async getAvailableTags() {
            try {
                const response = await Api2().get("admins/academy/" + this.$store.state.selectedAcademy + "/tags");
                if (response.data) {
                    this.availableTags = response.data.sort();
                }
            } catch (e) {
                this.showAlert("error", "Oops!", this.$t("message.error_generic"));
            }
        },

        async loadCheckinClasses() {
            try {
                const response = await Api2().get("admins/academy/" + this.$store.state.selectedAcademy);
                let schedule = response.data.schedule;
                let tmp = [];
                for (const d in schedule) {
                    for (const c of schedule[d]) {
                        var text = this.$t("message." + d) + ": " + c.name + " (" + c.start + "h)";
                        const value = c._id;
                        tmp.push({ value: value, text: text, professor: c.professorUser, day: c.day, start: c.start });
                    }
                }
                if (tmp.length > 0) {
                    const todayClasses = this.getTodaySchedule(tmp);
                    if (todayClasses && todayClasses.length) {
                        const todaysSchedule = this.$t("message.todays_schedule");
                        const schedule = this.$t("message.schedule");
                        this.availableCheckinClasses = [];
                        this.availableCheckinClasses.push({ header: todaysSchedule });
                        this.availableCheckinClasses = this.availableCheckinClasses.concat(todayClasses);
                        this.availableCheckinClasses.push({ header: schedule });
                        this.availableCheckinClasses = this.availableCheckinClasses.concat(tmp);
                    } else {
                        this.availableCheckinClasses = tmp;
                    }
                }
            } catch (e) {
                console.error("Failed to load checkin classes", e);
            }
        },

        // Filter methods
        clearFilters(clearAll) {
            this.minorsFilter = 'all';
            this.membershipTypeFilter = 'all';
            this.statusFilter = 'all';
            if (clearAll) {
                this.tagFilter = null;
                this.filterTableByTag();
            }
        },

        async filterTableByTag() {
            const value = this.tagFilter;
            this.clearFilters();
            this.loading = true;
            if (!value || value == "") {
                this.filteredMembers = this.members;
                this.loading = false;
            } else {
                try {
                    const response = await Api2().get(
                        "admins/academy/" +
                        this.$store.state.selectedAcademy +
                        "/members/tag/" +
                        encodeURIComponent(value)
                    );
                    const data = response.data;
                    if (data) {
                        this.filteredMembers = [];
                        for (const m of this.members) {
                            if (data.indexOf(m._id) >= 0) this.filteredMembers.push(m);
                        }
                    }
                    this.loading = false;
                } catch (e) {
                    this.loading = false;
                    this.showAlert("error", "Oops!", this.$t("message.error_generic"));
                }
            }
        },

        filterTableByMinors() {
            const value = this.minorsFilter;
            this.membershipTypeFilter = 'all';
            this.statusFilter = 'all';
            const list = this.members;
            if (value == 'minors') {
                if (list) {
                    let filtered = [];
                    for (const m of list) {
                        if (m.isMinor) filtered.push(m);
                    }
                    this.filteredMembers = filtered;
                }
            } else if (value == 'adults') {
                if (list) {
                    let filtered = [];
                    for (const m of list) {
                        if (!m.isMinor) filtered.push(m);
                    }
                    this.filteredMembers = filtered;
                }
            } else {
                this.clearFilters(true);
            }
        },

        filterTableByMembership() {
            const value = this.membershipTypeFilter;
            const list = this.members;
            this.minorsFilter = 'all';
            this.statusFilter = 'all';
            if (value && value != 'all') {
                if (list) {
                    let filtered = [];
                    for (const m of list) {
                        if (m.currentMembership == value) filtered.push(m);
                    }
                    this.filteredMembers = filtered;
                }
            } else {
                this.clearFilters(true);
            }
        },

        filterTableByStatus() {
            const value = this.statusFilter;
            this.minorsFilter = 'all';
            this.membershipTypeFilter = 'all';
            const list = this.members;

            if (value == 'with-membership') {
                this.filteredMembers = list.filter(m => m.lastPaymentStatus && m.lastPaymentStatus !== 'pending_payment');
            } else if (value == 'paid-membership') {
                this.filteredMembers = list.filter(m => m.paidMember);
            } else if (value == 'free-membership') {
                this.filteredMembers = list.filter(m => m.lastPaymentStatus && m.lastPaymentStatus !== 'pending_payment' && m.freeMembership);
            } else if (value == 'no-membership') {
                this.filteredMembers = list.filter(m => {
                    return !m.lastPaymentStatus || m.lastPaymentStatus === 'pending_payment';
                });
            } else {
                this.clearFilters(true);
            }
        },

        filterTable(value) {
            this.clearFilters();
            if (value == "") {
                this.filteredMembers = this.members;
            } else {
                value = value.toLowerCase();
                if (this.members) {
                    var filtered = [];
                    for (const m of this.members) {
                        const displayName = m.fName.toLowerCase() + ' ' + m.lName.toLowerCase();
                        if (
                            m.fName.toLowerCase().indexOf(value) >= 0 ||
                            m.lName.toLowerCase().indexOf(value) >= 0 ||
                            displayName.indexOf(value) >= 0
                        ) {
                            filtered.push(m);
                        }
                    }
                    this.filteredMembers = filtered;
                }
            }
        },

        selectAll() {
            if (!this.allSelected) {
                this.allSelected = true;
                for (let i of this.filteredMembers)
                    this.selectedItems.push(i);
            } else {
                this.allSelected = false;
                this.selectedItems = [];
            }
        },

        membersSort(items, index, isDesc) {
            if (index[0]) {
                const column = index[0];
                if (column != this.membersTableSort) {
                    this.navigateTo({
                        name: "memberstab",
                        params: { tabId: 0 },
                        query: { sort_members: index[0] + '|' + isDesc[0] }
                    });
                }
            }
            items.sort((a, b) => {
                if (index[0] == 'joined' || index[0] == 'dob') {
                    const aDate = a == '' ? null : new Date(a[index]);
                    const bDate = b == '' ? null : new Date(b[index]);
                    const ascending = !isDesc[0];
                    if (aDate === null && bDate !== null) {
                        return ascending ? -1 : 1;
                    } else if (aDate !== null && bDate === null) {
                        return ascending ? 1 : -1;
                    } else if (aDate === null && bDate === null) {
                        return 0;
                    } else {
                        return ascending ? aDate - bDate : bDate - aDate;
                    }
                } else if (index[0] == 'curriculumProgress') {
                    if (!isDesc[0]) return a[index] - b[index];
                    else return b[index] - a[index];
                } else if (index[0] == 'lastPaymentStatus') {
                    const priority = {
                        active: 1, completed: 1, trialing: 2, paused: 3,
                        past_due: 4, pending_payment: 5, expired: 6
                    };
                    const aVal = priority[a[index]] ?? 7;
                    const bVal = priority[b[index]] ?? 7;
                    return !isDesc[0] ? aVal - bVal : bVal - aVal;
                } else {
                    if (typeof a[index] !== 'undefined') {
                        if (!isDesc[0]) {
                            return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
                        } else {
                            return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
                        }
                    }
                }
            });
            return items;
        },

        // Action methods - emit events to parent
        openSendEmailDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-send-email-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        openSendNotiDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-send-notification-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        openTagsDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-tags-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        openSendDocuDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-send-document-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        openAssignSyllabusDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-assign-syllabus-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        openBulkCheckinDialog() {
            if (this.selectedItems && this.selectedItems.length > 0)
                this.$emit('open-bulk-checkin-dialog', this.selectedItems);
            else
                this.showAlert("info", this.$t("message.at_least_one_member"));
        },

        // Navigation methods
        viewMember(id, instanceId, section, crumbName) {
            if (instanceId)
                this.navigateTo({ name: "viewmember", params: { memberid: id }, query: { si: instanceId }, crumbName: crumbName });
            else if (section)
                this.navigateTo({ name: "viewmember", params: { memberid: id }, query: { section: section }, crumbName: crumbName });
            else
                this.navigateTo({ name: "viewmember", params: { memberid: id }, crumbName: crumbName });
        },

        goToTransaction(transactionId) {
            this.$emit('go-to-transaction', transactionId);
        },

        goToSellMembership(item) {
            this.navigateTo({
                name: "sellproduct",
                params: { productId: 'membership' },
                query: { userId: item._id },
            });
        },

        // Member interaction methods
        displayPhoneDialog(member) {
            this.$emit('display-phone-dialog', member);
        },

        displaySocialPostDialog(member) {
            this.$emit('display-social-post-dialog', member);
        },

        viewUserCode(member) {
            this.$emit('view-user-code', member);
        },
    }
};
</script>

<style scoped>
.disabled-menu {
    color: gray;
}

.clickable {
    cursor: pointer;
}

.supporting-text {
    font-size: 0.875rem;
    color: var(--v-plusTextSecondary-base);
}

.mobile-header-border {
    border: 1px solid var(--v-plusBorder-base) !important;
    padding: 1.25rem 1rem 1.25rem 1rem !important;
}

@media (min-width: 1264px) {
    .mobile-header-border {
        border: none !important;
        border-top: none !important;
        padding: 0 !important;
    }
}

.border-filter {
    border: 1px solid var(--v-plusBorder-base) !important;
    background-color: var(--v-plusBackground-base) !important;
}
</style>

<style>
@media (max-width: 959px) {
    .active-members-table .v-data-table__checkbox {
        padding: 0 4px !important;
        width: 32px !important;
    }

    .active-members-table tbody td:nth-child(2) {
        padding-left: 4px !important;
    }
}
</style>